module.exports = __webpack_public_path__ + "img/ce469c1.jpg";